/** Retained path -> the first branch it sheds, directly below. */
export const GAP_MAIN = 18;
/** Branch -> branch within the same column. */
export const GAP_STACK = 12;
/** Cohort lane -> cohort lane. */
export const LANE_GAP = 26;
/** Floor so a sub-pixel ribbon does not vanish entirely. */
export const MIN_RIBBON = 1.6;
/** Height a card needs for title + detail + count + share. */
export const MIN_FULL = 92;
/** Height a card needs for title + count + share. */
export const MIN_MID = 66;
/** Top of the first row of nodes; leaves room for column labels. */
export const Y0 = 96;
export const X0 = 20;
export const BOTTOM_PAD = 34;
export const LABEL_Y = 44;
export const RULE_Y = 58;
/** Below this the SVG scrolls rather than shrinking into illegibility. */
export const MAX_MIN_WIDTH = 1080;
/** Card padding for text. */
export const NODE_PAD = 14;
